<mat-form-field class="search with-prefix" [class.active]="isSearchActive$ | async">
    <mat-icon matPrefix>search</mat-icon>
    <input
        #inputField
        matInput
        autocomplete="off"
        name="search"
        placeholder="Search"
        value=""
        (keyup.esc)="inputField.blur()"
        [matAutocomplete]="searchResultsAuto"
        [(ngModel)]="text"
        (ngModelChange)="search.search($event)"
        (paste)="onPaste($event)"
    />
    <mat-autocomplete
        #searchResultsAuto="matAutocomplete"
        class="global-search-results"
        panelWidth="auto"
        [autoActiveFirstOption]="true"
        [displayWith]="displayFn"
        (optionSelected)="onOptionSelected($event)"
    >
        <mat-option
            *ngFor="let res of search.results$ | async"
            [value]="res"
            [disabled]="res.type === 'loading'"
            [class.loading-option]="res.type === 'loading'"
            (mousedown)="onOptionMousedown($event, res)"
            (click)="onOptionClick(res)"
        >
            <div class="history-item-wrapper" *ngIf="res.type !== 'no_results' && res.type !== 'loading'">
                <div class="badge">
                    <ce-station-badge
                        *ngIf="res.type === 'station'"
                        [station]="res.station?.data.station"
                        [globalSearchStation]="res.globalSearchStation"
                    ></ce-station-badge>
                    <ce-connector-badge
                        *ngIf="res.type === 'connector'"
                        [connector]="res.connector"
                        [globalSearchConnector]="res.globalSearchConnector"
                        [location]="
                            res.station?.data?.station?.location?.name ||
                            res.station?.data?.station?.name ||
                            res.globalSearchConnector?.location?.locationName ||
                            res.globalSearchConnector?.station?.stationName
                        "
                    ></ce-connector-badge>
                    <ce-ticket-badge *ngIf="res.type === 'ticket'" [ticket]="res.ticket"></ce-ticket-badge>
                    <ce-organization-badge
                        *ngIf="res.type === 'organization'"
                        [globalSearchOrganization]="res.globalSearchOrganization"
                    ></ce-organization-badge>
                    <ce-location-badge
                        *ngIf="res.type === 'location'"
                        [location]="res.location"
                        [globalSearchLocation]="res.globalSearchLocation"
                    ></ce-location-badge>
                </div>
                <button
                    *ngIf="search.isShowingHistory$ | async"
                    class="remove-history-btn"
                    (click)="onRemoveFromHistory($event, res)"
                    (mousedown)="$event.stopPropagation()"
                    matTooltip="Remove from history"
                >
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div *ngIf="res.type === 'no_results'">No results</div>
            <div *ngIf="res.type === 'loading'" class="loading-spinner-container">
                <mat-spinner diameter="20" color="primary"></mat-spinner>
                <span>Searching...</span>
            </div>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
